const ua = navigator.userAgent || '';

export const isMobile = /\bmobile\b/i.test(ua);
export const isAndroid = isMobile && /\bandroid\b/i.test(ua);
export const isIos = isMobile && /\bmac os\b/i.test(ua);
